import React from "react";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Typography from "@material-ui/core/Typography";
import translations from "../utils/translations";
import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../store/broker";
import { useSelector } from "react-redux";

export default function BackToApplication(props) {
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  const textToDisplay = props.text
    ? props.text
    : translations[languagepreference].backToApplication;
  return (
    <div onClick={props.onClick}>
      <IconButton
        aria-label="Back to application"
        component="span"
        style={{ borderRadius: "10", paddingLeft:0 }}
      >
        <ArrowBackIosIcon fontSize={"small"} />{" "}
        <Typography
          color="textSecondary"
          style={{
            fontSize: 12,
            color: "gray",
            fontWeight: "bold",
          }}
        >
          {textToDisplay}
        </Typography>
      </IconButton>
    </div>
  );
}
